export default "__VITE_ASSET__DPVu8pzV__"